module.exports = __webpack_public_path__ + "static/img/kf_cloud_00002.0fd9613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00002.jpg
// module id = 173
// module chunks = 1